import React from "react";
import {Button, Container, Grid, Icon, Loader, Table} from "semantic-ui-react";
import {connect} from "react-redux";
import * as InteractiveMapActions from "../actions/InteractiveMapActions";
import {reloadLeg, reloadLegs, reloadShips} from "../functions/airtable";
import moment from "moment";

class ListPage extends React.Component {

    state = {
        sort: "departure.date",
        desc: false,
        waiting: false,
        visibleRoutes: [],
        reloadingUpdates: [],
    };

    componentDidMount() {
        this.props.fetchRoutes();
    }

    componentWillReceiveProps(newProps) {

        if (this.state.visibleRoutes.length === 0) {
            this.sort(newProps.routes);
        }

    }

    compareValues(key, desc) {
        //https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
        return function (a, b) {
            if (key.indexOf(".") !== -1) {
                const keys = key.split(".");
                console.log(keys);
                a = a[keys[0]];
                b = b[keys[0]];
                key = keys[1];
            }
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                // property doesn't exist on either object
                return 0;
            }

            const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];


            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            console.log(varA, varB, comparison);
            return (
                (desc) ? (comparison * -1) : comparison
            );
        };
    }

    sortOn(field) {
        const {sort, desc} = this.state;
        if (sort === field) {
            this.setState({desc: !desc}, this.sort);
        } else {
            this.setState({sort: field, desc: false}, this.sort);
        }
    }

    sort(routes) {
        if (!routes) routes = this.props.routes;
        const {sort, desc} = this.state;
        this.setState({visibleRoutes: routes.sort(this.compareValues(sort, desc))});
    }

    reloadLeg(id) {
        this.setState({waiting: true});
        reloadLeg(id).then(() => {
            window.location.reload(true);
        })
    }

    reloadLegs() {
        this.setState({waiting: true});
        reloadLegs((update) => {
            let reloadingUpdates = this.state.reloadingUpdates;
            reloadingUpdates.push(update);
            this.setState({reloadingUpdates})
        }).then(() => {
            window.location.reload(true);
        })
    }

    reloadShips() {
        this.setState({waiting: true});
        reloadShips((update) => {
            let reloadingUpdates = this.state.reloadingUpdates;
            reloadingUpdates.push(update);
            this.setState({reloadingUpdates})
        }).then(() => {
            window.location.reload(true);
        })
    }

    render() {

        const {sort, desc, visibleRoutes, waiting} = this.state;
        const {ships} = this.props;

        const averageAverageSpeed = 10;

        // const average = arr => arr.reduce( ( p, c ) => p + c, 0 ) / arr.length;
        // let averageAverageSpeed = average(routes.map(route => route.averageSpeed));
        // console.log(averageAverageSpeed);

        return <div className="page-container">
            <br /><br />
            {waiting ? <Container>
                    <Grid>
                        <Grid.Row centered><Loader active/></Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                            {this.state.reloadingUpdates.reverse().map(update =>
                                <p><pre>{update}</pre></p>
                            )}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Container> :
                <Container>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column>
                                <Button onClick={() => this.reloadLegs()}>Reload legs</Button>
                                <Button onClick={() => this.reloadShips()}>Reload ships</Button>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row centered>
                            <Grid.Column>
                                <Table>
                                    <thead>
                                    <tr>
                                        <th/>
                                        <th onClick={() => this.sortOn("id")}>ID {(sort === "id" ?
                                            <Icon name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("departure.date")}>From
                                            date {(sort === "departure.date" ?
                                                <Icon
                                                    name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("departure.city")}>From {(sort === "departure.city" ?
                                            <Icon name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("arrival.date")}>To
                                            date {(sort === "arrival.date" ?
                                                <Icon
                                                    name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("arrival.city")}>To {(sort === "arrival.city" ?
                                            <Icon name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("ship")}>Ship {(sort === "ship" ?
                                            <Icon name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("duration")}>Duration {(sort === "duration" ?
                                            <Icon name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("distance")}>Distance {(sort === "distance" ?
                                            <Icon name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                        <th onClick={() => this.sortOn("averageSpeed")}>Avg. speed
                                            [kts] {(sort === "averageSpeed" ?
                                                <Icon
                                                    name={"sort " + (desc ? "descending" : "ascending")}/> : null)}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {visibleRoutes.map(route => <Table.Row
                                        active={route.averageSpeed > averageAverageSpeed}
                                        key={route.id}>
                                        <td>
                                            {/*<Button.Group size="small">*/}
                                            {/*<Button icon="remove" basic color="red"/>*/}
                                            <Button icon="refresh" basic color="blue" onClick={() => {
                                                this.reloadLeg(route.id)
                                            }}/>
                                            {/*</Button.Group>*/}
                                        </td>
                                        <td>{route.id}</td>
                                        <td>{moment(route.departure.date).format()}</td>
                                        <td>{route.departure.city}, {route.departure.country}</td>
                                        <td>{moment(route.arrival.date).format()}</td>
                                        <td>{route.arrival.city}, {route.arrival.country}</td>
                                        <td>
                                            <span style={{color: "#ccc"}}>{route.ship}</span>
                                            {ships && ships[route.ship] && (ships[route.ship].company + " " + ships[route.ship].name)}
                                        </td>
                                        <td>{route.duration}</td>
                                        <td>{parseInt(route.distance)}</td>
                                        <Table.Cell error={route.averageSpeed > averageAverageSpeed}>
                                            {parseInt(route.averageSpeed * 100) / 100}
                                        </Table.Cell>
                                    </Table.Row>)}
                                    </tbody>
                                </Table>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Container>
            }
        </div>
    }
}


export default connect(state => ({
    routes: state.interactiveMap.routes,
    ships: state.interactiveMap.shipsById,
}), dispatch => ({
    fetchRoutes: () => dispatch(InteractiveMapActions.fetchInteractiveMapRoutes()),
}))(ListPage)


// WEBPACK FOOTER //
// ./src/homepage/ListPage.js